import { useQuery } from "react-query";
import { publicClient } from "../api";
import { BENEFITS_URL } from "../urls";
import { Benefit } from "./usePlan";

const getBenefits = () => async () => {
  const response = await publicClient.get(BENEFITS_URL);
  return response.data;
};

export function useBenefits() {
  const benefitsQuery = useQuery<Benefit[]>(BENEFITS_URL, getBenefits());
  return benefitsQuery;
}
